import {AbstractFilter} from './AbstractFilter';
import {Session} from 'com/gongxigames/math/core/game/session/Session';
import {Message} from 'com/gongxigames/math/core/game/message/Message';
import {Action} from 'com/gongxigames/math/core/game/enums/Action';

export class Position {
    reel?: number;
    row?: number;
}

export class SymbolPositionFilter extends AbstractFilter {
    private positions: Position[];
    private symbol: number;

    constructor(name: string, position: Position[], symbol: number) {
        super(name);
        this.positions = position;
        this.symbol = symbol;
    }

    public filter(response: Message, session: Session): boolean {
        const action = response.getAction();

        if (action !== Action.SPIN && action !== Action.FREESPIN && action !== Action.RESPIN &&
            // @ts-ignore TODO: refactoring required!
            action !== Action.MINISPIN
        ) {
            return true;
        }

        const spin = this.getSpin(response);
        const rowAmount = spin.symbolIds[0].length;

        for (const pos of this.positions) {
            const randomRow = Math.floor(Math.random() * rowAmount);
            const row = pos.row === undefined ? randomRow : pos.row;

            if (spin.symbolIds[pos.reel!][row] !== this.symbol) {
                return false;
            }
        }

        return true;
    }
}
